// helpers/convertImageToBase64.js
export default function convertImageToBase64(filePath) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(filePath);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  